import PropTypes from 'prop-types'

const Checkbox = ({ name, value, checked, onChange }) => {
  const chequeado = value ? value[name] : checked
  return <input type="checkbox" name={name} checked={chequeado} onChange={onChange} />
}

Checkbox.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.object,
  checked: PropTypes.bool,
  onChange: PropTypes.func.isRequired
}

export default Checkbox
